import { useEffect, useState } from 'react';
import type { ProductCategory } from '../types';
import { productService } from '../services/api';

/**
 * Fetches the product categories that currently have at least one active
 * product, so category links/filters never point at an empty catalog page.
 * Returns `null` while loading; an empty array if there are no categorized
 * products (or the request fails), in which case callers should show only
 * "All Products".
 */
export function useProductCategories(): ProductCategory[] | null {
  const [categories, setCategories] = useState<ProductCategory[] | null>(null);

  useEffect(() => {
    let active = true;
    productService.getCategories()
      .then(c => { if (active) setCategories(c); })
      .catch(() => { if (active) setCategories([]); });
    return () => { active = false; };
  }, []);

  return categories;
}
